import { AgGridReact } from 'ag-grid-react';
import React, { ChangeEvent, useCallback, useRef, useState } from 'react';
import { getEmployeeList } from 'src/apis/employeeApi';
import { blueButtonClass, BRDiv, defaultFormText, grayButtonClass, inputFormHeightOption } from 'src/components/common/common';
import { CodeForm } from 'src/components/common/form/CodeForm';
import { DropDownForm } from 'src/components/common/form/DropdownForm';
import { InputForm } from 'src/components/common/form/input/InputForm';
import { SingleDateForm } from 'src/components/common/form/SingleDateForm';
import ModalWrapper from 'src/components/common/modal/ModalWrapper';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import useUiuxStore from 'src/store/useUiuxStore';
import { InfoCodeSearchFieldConfig } from 'src/types/info-form';
import { useMouseContent } from 'src/utils/mouse/mouseContent';
import { formatDate, validateString } from 'src/utils/string/stringUtil';
import { DetailTable_KSK2011_R01 } from './DetailTable_KSK2011_R01';
import { defaultKSK2011_R01EditDto, KSK2011_R01DetailDto, KSK2011_R01EditDto } from './Dto_KSK2011_R01';
import { useKSK2011_R01Store } from './Store_KSK2011_R01';

interface Props {
	handleWorkSaveClick: () => void;
	handleWorkDeleteClick: () => void;
	detailGridRef: React.RefObject<AgGridReact<KSK2011_R01DetailDto> | null>;
}

export const Modal_KSK2011_R01 = ({
    handleWorkSaveClick,
	handleWorkDeleteClick,
	detailGridRef,
}: Props) => {
    const { 
		editKSK2011_R01, setEditKSK2011_R01,
		modalVisible, setModalVisible
	} = useKSK2011_R01Store();
	const { workPlaceList, jobTeamList } = useCommonCodeStore();
	const { setCodeSearchModalProps, setAddressModalProps } = useUiuxStore();

    const modalRef = useRef<HTMLDivElement>(null);
    const modalInfoRef = useRef<HTMLDivElement>(null);
    const isResizing_modal = useRef(false);

	
	// 매출일자 달력 팝업 상태
	const [workDtPickerVisible, setWorkDtPickerVisible] = useState(false);
	const [workDtPickerPos, setWorkDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	const empInfoHandleFoucsId = 'infoEmpInput';

    const RESIZER_MODAL = {
        code: 'KSK2011_R01_modal',
        type: 'width',
        storageKey: 'KSK2011_R01-modal-split-width',
        min: 5,
        max: 80,
        default: 50
    } as const;

	const buttonClassName = (isDisabled?: boolean) => 
		`text-white rounded-[4px] w-[100px] font-semibold flex items-center justify-center h-[45px] flex items-center ${defaultFormText} ${
			isDisabled 
				? grayButtonClass
				: blueButtonClass
		}`;

	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'workEmp',
			category: '담당자',
			focusId: empInfoHandleFoucsId,
			responseMapping: {
				empNo: 'workEmp',
				empNm: 'workEmpNm'
			},
			// extraFilter: () => ({
			// 	workEmp: editKSK2011_R01?.workEmp || '',
			// 	workEmpNm: editKSK2011_R01?.workEmpNm || '',
			// }),
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			}
		}
	];

    const {
        splitValue: splitValue_modal,
        handleMouseDown: handleMouseDown_modal,
    } = useMouseContent({
        resizer: RESIZER_MODAL,
        isResizing: isResizing_modal,
        containerRef: modalRef,
        infoRef: modalRef
    });

	
	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: editKSK2011_R01,
		setEditData: setEditKSK2011_R01,
		defaultData: defaultKSK2011_R01EditDto,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'KSK2011_R01'
	});
	
	const handleDateChange = useCallback((field: keyof KSK2011_R01EditDto, value: any) => {
		setEditKSK2011_R01({
			...defaultKSK2011_R01EditDto,
			...editKSK2011_R01,
			[field]: value
		});
	}, [editKSK2011_R01]);

	const handleChange = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;

		setEditKSK2011_R01({
			...defaultKSK2011_R01EditDto,
			...editKSK2011_R01,
			[name]: value
		});
		
	}

	
    // 3. 모든 Hook 호출이 끝난 후 조건부 리턴을 수행합니다.
    // if (!modalVisible) return null;

    return (
        <ModalWrapper
            size={'xl'}
            defaultWidth={1500}
            overlay={true}
            onOverlayClick={() => setModalVisible(!modalVisible)}
            onEscKeyDown={() => {
                setModalVisible(!modalVisible);
            }}
        >
            <div className="w-full h-[5%] flex items-center px-[24px] bg-gray-100">
                <p className={`font-bold ${inputFormHeightOption}`}>
                    공정지시 등록
                </p>
            </div>
			
			
			<div className="h-[27%] max-h-full flex flex-wrap content-start pt-[12px] pl-[12px] pr-[12px] overflow-y-auto">
							
				<InputForm 
					title="작업지시No" 
					value={editKSK2011_R01?.productOrderNo || ""} 
					editable={false}
					name="productOrderNo" 
					wrapperOption={{
						wrapperStyle: "w-[540px] min-w-[540px] mb-[4px]",
						titleStyle: "w-[150px] min-w-[150px] text-left",
						inputStyle: "w-[380px] min-w-[380px] " + inputFormHeightOption,
					}}
					onChange={handleChange} 
				/>
				<InputForm 
					title="공정지시No" 
					value={editKSK2011_R01?.productWorkNo || ""} 
					editable={false}
					name="productOrderNo" 
					wrapperOption={{
						wrapperStyle: "w-[540px] min-w-[540px] mb-[4px]",
						titleStyle: "w-[150px] min-w-[150px] text-left",
						inputStyle: "w-[380px] min-w-[380px] " + inputFormHeightOption,
					}}
					onChange={handleChange} 
				/>
				<BRDiv />
				<SingleDateForm
					title="생산일자"
					value={editKSK2011_R01?.workDt ? new Date(editKSK2011_R01.workDt) : undefined}
					setValue={(value: Date | undefined) => handleDateChange('workDt', formatDate(value))}
					editable={true}
					visible={workDtPickerVisible} setVisible={setWorkDtPickerVisible}
					onChange={handleChange}
					pickerPos={workDtPickerPos} setPickerPos={setWorkDtPickerPos}
				/>
				<CodeForm
					label="품목코드"
					value={editKSK2011_R01?.itemCd || ""}
					custNmValue={editKSK2011_R01?.itemNm || ""}
					editable={false}
					name="itemCd"
					handleChange={
						() => { }
						// handleChange
					}
					onDoubleClick={() => {}}
					onKeyDown={() => { }}
					wrapperOption = {{
						wrapperStyle: "w-[700px] min-w-[700px] mr-[10px] mb-[5px]",
						titleStyle: "w-[150px] min-w-[150px] text-left",
						codeInputStyle: "w-[200px] min-w-[200px]",
						custNmInputStyle: "w-[355px] min-w-[355px]"
					}}
				/>
				<BRDiv />
				<InputForm title="규격" value={editKSK2011_R01?.itemSpec || ""}
					editable={false}
					name="itemSpec"
					onChange={handleChange} />
				<InputForm title="단위" value={editKSK2011_R01?.itemUnit || ""}
					editable={false}
					name="itemUnit"
					onChange={handleChange} />
				<BRDiv />
				<InputForm title="작업지시량(최대)" value={editKSK2011_R01?.productOrderQtyView || 0}
					editable={false}
					name="productOrderQtyView"
					onChange={handleChange} 
					dragSelectAll={true}
					/>
				<InputForm title="작업지시량" value={editKSK2011_R01?.orderQty || 0}
					// 이미 발급한 공정지시의 경우 작업지시잔량을 수정할 수 없습니다.	
					editable={true}
					name="orderQty"
					onChange={handleChange} 
					dragSelectAll={true}
					/>
				<BRDiv />
				
				<DropDownForm
					title="작업공정"
					name="workplaceCd"
					initLabelLess={true}
					value={editKSK2011_R01?.workplaceCd}
					data={workPlaceList}
					editable={true}
					onChange={handleChange}
				/>
				
				<DropDownForm
					title="작업팀"
					name="jobTeam"
					initLabelLess={true}
					value={editKSK2011_R01?.jobTeam}
					data={jobTeamList}
					editable={true}
					onChange={handleChange}
				/>

				<CodeForm
					label="작업자"
					value={editKSK2011_R01?.workEmp || ""}
					custNmValue={editKSK2011_R01?.workEmpNm || ""}
					editable={true}
					name="workEmp"
					handleChange={getFieldHandlers('workEmp').onChange}
					onDoubleClick={getFieldHandlers('workEmp').onDoubleClick}
					onKeyDown={getFieldHandlers('workEmp').onEnterKeyDown}
				/>
			</div>
			<div className="h-[50%] max-h-full px-[12px]">
				<DetailTable_KSK2011_R01 gridRef={detailGridRef}/>
			</div>
            <div className="w-full h-[9%] flex items-center justify-center gap-[8px]">
                <button
                    className={buttonClassName(false)}
                    onClick={handleWorkSaveClick}
                    disabled={false}
                >
                    저장
                </button>
				{validateString(editKSK2011_R01?.productWorkNo || "") && (
					<button
						className={buttonClassName(false)}
						onClick={handleWorkDeleteClick}
						disabled={false}
					>
						삭제
					</button>
				)}
                <button
                    className={buttonClassName(false)}
                    onClick={() => setModalVisible(!modalVisible)}
                    disabled={false}
                >
                    닫기
                </button>
            </div>
        </ModalWrapper>
    );
};

